import { blobticService } from '../../Commun/services/blobticService';

export interface ProjectDto {
    PRJ_IDF: number;
    PRJ_LIB: string;
    PRJ_DESCRIPTION?: string;
    CUS_IDF: number;
    PRJ_STATUS?: string;
    PRJ_START_DATE?: string;
    PRJ_END_DATE?: string;
    LAST_UPDT?: string;
    USER_IDF?: number;
}

export interface Project {
    id: number;
    name: string;
    description?: string;
    customerId: number;
    createdDate: string; // Mapping PRJ_START_DATE? Or LAST_UPDT?
    modifiedDate?: string;
    isActive: boolean; // Computed from PRJ_STATUS?
}

const mapDtoToModel = (dto: ProjectDto): Project => ({
    id: dto.PRJ_IDF,
    name: dto.PRJ_LIB,
    description: dto.PRJ_DESCRIPTION,
    customerId: dto.CUS_IDF,
    createdDate: dto.PRJ_START_DATE || dto.LAST_UPDT || new Date().toISOString(),
    modifiedDate: dto.LAST_UPDT,
    isActive: dto.PRJ_STATUS === 'Active' || dto.PRJ_STATUS === 'A'
});

const mapModelToDto = (model: Partial<Project>): Partial<ProjectDto> => ({
    PRJ_IDF: model.id,
    PRJ_LIB: model.name,
    PRJ_DESCRIPTION: model.description,
    CUS_IDF: model.customerId,
    // PRJ_STATUS field management if needed
});

export const projectsApi = {
    getAll: async () => {
        const response = await blobticService.executeZoomRequest<ProjectDto[]>({
            ZoomKey: 'Blobtic_Maker',
            Action: { OKey: 'Blobtic_Maker,maker_project,Select' }
        });
        return { data: (response.data || []).map(mapDtoToModel) };
    },

    getById: async (id: number) => {
        const response = await blobticService.executeZoomRequest<ProjectDto[]>({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_project,Select',
                PRJ_IDF: id
            }
        });
        const dto = response.data?.[0];
        return { data: dto ? mapDtoToModel(dto) : null };
    },

    create: async (project: Partial<Project>) => {
        const dto = mapModelToDto(project);
        const response = await blobticService.executeZoomRequest<ProjectDto[]>({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_project,Insert',
                ...dto
            }
        });
        // Assuming insert returns the created object or we need to fetch it
        // Blobtic generic insert might return the inserted row if implemented so
        return { data: response.data?.[0] ? mapDtoToModel(response.data[0]) : null };
    },

    update: async (id: number, project: Partial<Project>) => {
        const dto = mapModelToDto(project);
        const response = await blobticService.executeZoomRequest<ProjectDto[]>({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_project,Update',
                PRJ_IDF: id,
                ...dto
            }
        });
        return { data: response.data?.[0] ? mapDtoToModel(response.data[0]) : null };
    },

    delete: async (id: number) => {
        await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_project,Delete',
                PRJ_IDF: id
            }
        });
        return { success: true };
    }
};
